import {
  FacebookIcon,
  YoutubeIcon,
  TwitterIcon,
  PinterestIcon,
  InstagramIcon,
} from "../icons/icons";

const socialLinks = [
  { name: "Facebook", icon: <FacebookIcon />, href: "/" },
  { name: "Youtube", icon: <YoutubeIcon />, href: "/" },
  { name: "Twitter", icon: <TwitterIcon />, href: "/" },
  { name: "Pinterest", icon: <PinterestIcon />, href: "/" },
  { name: "Instagram", icon: <InstagramIcon />, href: "/" },
];

export default socialLinks;
